import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface authSliceType {
  tokens?: { refresh: string; access: string };
  body?: {
    user_id: number;
    user_name: string;
    is_admin: boolean;
    agency: { name: string; id: number };
    branch: { name: string; id: number }[];
    permissions: string[];
  };
}

const initialState: authSliceType = {
  tokens: undefined,
  body: undefined,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (
      state,
      action: PayloadAction<{ refresh: string; access: string, redirectTo?: string }>
    ) => {
      state.tokens = {refresh: action.payload.refresh, access: action.payload.access};
      state.body = JSON.parse(atob(action.payload.access.split(".")[1]));
      if (state.body) {
        state.body.is_admin =
          typeof state.body.is_admin === "string"
            ? state.body.is_admin === "true"
            : state.body.is_admin;
      }
      if(action.payload.redirectTo) {
        setTimeout((loc) => {window.location.href = loc;}, 1000, action.payload.redirectTo);
      }
    },
    logout: (state, action: PayloadAction) => {
      state.tokens = undefined;
      state.body = undefined;
    },
    // loadPermissions: (state, action: PayloadAction<string[]>) => {
    //     state.permissions = action.payload;
    // }
  },
});

export const login = authSlice.actions.login;
export const logout = authSlice.actions.logout;
// export const loadPermissions = authSlice.actions.loadPermissions;
export default authSlice.reducer;
